import axios from "axios";

export const getBackendURL = async () => {
  const data = {
    backendURL: "https://nextdrought-api-wrd-dev.eu.mike-cloud-dev.com",
    geoserverURL: "https://nextdrought-geoserver.azurewebsites.net",
  };

  try {
    const response = await axios.get("/getBackendURL");

    return response.data;
  } catch (error) {
    return data;
  }
};
